import { render, staticRenderFns } from "./TeacherManagerClass.vue?vue&type=template&id=60d6e2e7&scoped=true&"
import script from "./TeacherManagerClass.vue?vue&type=script&lang=js&"
export * from "./TeacherManagerClass.vue?vue&type=script&lang=js&"
import style0 from "./TeacherManagerClass.vue?vue&type=style&index=0&id=60d6e2e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d6e2e7",
  null
  
)

export default component.exports